// TODO This contains third-party code. Should investigate to see if this could be moved to bower instead and then extended in Glu
// Based upon Backbone-Nested 2.0.1 - Copyright (c) 2011-2012 Aidan Feldman (MIT License)
define('glu/nestedModel',['require','./$','./util','./model'],function(require) {
    'use strict';

    var $ = require('./$'),
        util = require('./util'),
        Model = require('./model');

    var delayedTriggers = [],
        nestedChanges;

    function getAttrPath(attrStrOrPath) {
        var path;

        if (util.isString(attrStrOrPath)) {
            // TODO this parsing can probably be more efficient
            path = (attrStrOrPath === '') ? [''] : attrStrOrPath.match(/[^\.\[\]]+/g);
            path = util.map(path, function(val) {
                // convert array accessors to numbers
                return val.match(/^\d+$/) ? parseInt(val, 10) : val;
            });
        } else {
            path = attrStrOrPath;
        }

        return path;
    }

    function createAttrStr(attrPath) {
        var attrStr = attrPath[0];
        util.each(util.rest(attrPath), function(attr) {
            attrStr += util.isNumber(attr) ? ('[' + attr + ']') : ('.' + attr);
        });

        return attrStr;
    }

    function deepClone(obj) {
        return $.extend(true, {}, obj);
    }

    function walkPath(obj, attrPath, callback, scope) {
        var val = obj,
            childAttr;

        // walk through the child attributes
        for (var i = 0; i < attrPath.length; i++) {
            callback.call(scope || this, val, attrPath.slice(0, i + 1), attrPath[i + 1]);

            childAttr = attrPath[i];
            val = val[childAttr];
            if (!val) {
                // at the leaf
                break;
            }
        }
    }

    return Model.extend({
        get: function(attrStrOrPath) {
            var attrPath = getAttrPath(attrStrOrPath),
                result;

            walkPath(this.attributes, attrPath, function(val, path) {
                var attr = util.last(path);
                if (path.length === attrPath.length) {
                    // attribute found
                    result = val[attr];
                }
            });

            return result;
        },

        has: function(attr) {
            // for some reason this is not how Backbone.Model is implemented - it accesses the attributes object directly
            var result = this.get(attr);
            return !(result === null || util.isUndefined(result));
        },

        set: function(key, value, opts) {
            var newAttrs = deepClone(this.attributes),
                attrPath,
                unsetObj,
                validated;

            if (util.isString(key)) {
                // Backbone 0.9.0+ syntax: `model.set(key, val)` - convert the key to an attribute path
                attrPath = getAttrPath(key);
            } else if (util.isArray(key)) {
                // attribute path
                attrPath = key;
            }

            if (attrPath) {
                opts = opts || {};
                this.setAttr(newAttrs, attrPath, value, opts);
            } else { // it's an Object
                opts = value || {};
                var attrs = key;
                for (var attrStr in attrs) {
                    if (attrs.hasOwnProperty(attrStr)) {
                        this.setAttr(newAttrs,
                            getAttrPath(attrStr),
                            opts.unset ? void 0 : attrs[attrStr],
                            opts);
                    }
                }
            }

            nestedChanges = Model.prototype.changedAttributes.call(this);

            if (opts.unset && attrPath && attrPath.length === 1) { // assume it is a singular attribute being unset
                // unsetting top-level attribute
                unsetObj = {};
                unsetObj[key] = void 0;
                nestedChanges = util.omit(nestedChanges, util.keys(unsetObj));
                validated = Model.prototype.set.call(this, unsetObj, opts);
            } else {
                unsetObj = newAttrs;

                // normal set(), or an unset of nested attribute
                if (opts.unset && attrPath) {
                    // make sure Backbone.Model won't unset the top-level attribute
                    opts = util.extend({}, opts);
                    delete opts.unset;
                } else if (opts.unset && util.isObject(key)) {
                    unsetObj = key;
                }
                nestedChanges = util.omit(nestedChanges, util.keys(unsetObj));
                validated = Model.prototype.set.call(this, unsetObj, opts);
            }


            if (!validated) {
                // reset changed attributes
                this.changed = {};
                nestedChanges = {};
                return false;
            }


            this.runDelayedTriggers();
            return this;
        },

        unset: function(attr, options) {
            return this.set(attr, void 0, util.extend({}, options, {
                unset: true
            }));
        },

        clear: function(options) {
            nestedChanges = {};

            // Mostly taken from Backbone.Model.set, modified to work for NestedModel.
            options = options || {};
            // clone attributes so validate method can't mutate it from underneath us.
            var attrs = util.clone(this.attributes);

            var changed = this.changed = {};
            var model = this;

            var setChanged = function(obj, prefix, options) {
                // obj will be an Array or an Object
                util.each(obj, function(val, attr) {
                    var changedPath = prefix;
                    if (util.isArray(obj)) {
                        // assume there is a prefix
                        changedPath += '[' + attr + ']';
                    } else if (prefix) {
                        changedPath += '.' + attr;
                    } else {
                        changedPath = attr;
                    }

                    val = obj[attr];
                    if (util.isObject(val)) { // clear child attrs
                        setChanged(val, changedPath, options);
                    }
                    if (!options.silent) {
                        model.delayedChange(changedPath, null, options);
                    }
                    changed[changedPath] = null;
                });
            };
            setChanged(this.attributes, '', options);

            this.attributes = {};

            // Fire the `"change"` events.
            if (!options.silent) {
                this.delayedTrigger('change');
            }

            this.runDelayedTriggers();
            return this;
        },

        add: function(attrStr, value, opts) {
            var current = this.get(attrStr);
            if (!util.isArray(current)) {
                throw new Error('current value is not an array');
            }
            return this.set(attrStr + '[' + current.length + ']', value, opts);
        },

        remove: function(attrStr, opts) {
            opts = opts || {};

            var attrPath = getAttrPath(attrStr),
                aryPath = util.initial(attrPath),
                val = this.get(aryPath),
                i = util.last(attrPath);

            if (!util.isArray(val)) {
                throw new Error('remove() must be called on a nested array');
            }

            // only trigger if an element is actually being removed
            var trigger = !opts.silent && (val.length >= i + 1),
                oldEl = val[i];

            // remove the element from the array
            val.splice(i, 1);
            opts.silent = true; // Triggers should only be fired in trigger section below
            this.set(aryPath, val, opts);

            if (trigger) {
                attrStr = createAttrStr(aryPath);
                this.trigger('remove:' + attrStr, this, oldEl);
                for (var aryCount = aryPath.length; aryCount >= 1; aryCount--) {
                    attrStr = createAttrStr(util.first(aryPath, aryCount));
                    this.trigger('change:' + attrStr, this, oldEl);
                }
                this.trigger('change', this, oldEl);
            }

            return this;
        },

        changedAttributes: function(diff) {
            var backboneChanged = Model.prototype.changedAttributes.call(this, diff);
            if (util.isObject(backboneChanged)) {
                return util.extend({}, nestedChanges, backboneChanged);
            }
            return false;
        },

        toJSON: function() {
            return deepClone(this.attributes);
        },


        // private
        delayedTrigger: function( /* the trigger args */ ) {
            delayedTriggers.push(arguments);
        },

        delayedChange: function(attrStr, newVal, options) {
            this.delayedTrigger('change:' + attrStr, this, newVal, options);

            // Check if `change` even *exists*, as it won't when the model is
            // freshly created.
            if (!this.changed) {
                this.changed = {};
            }

            this.changed[attrStr] = newVal;
        },

        runDelayedTriggers: function() {
            while (delayedTriggers.length > 0) {
                this.trigger.apply(this, delayedTriggers.shift());
            }
        },

        // note: modifies `newAttrs`
        setAttr: function(newAttrs, attrPath, newValue, opts) {
            opts = opts || {};

            var fullPathLength = attrPath.length;
            var model = this;

            walkPath(newAttrs, attrPath, function(val, path, next) {
                var attr = util.last(path);
                var attrStr = createAttrStr(path);

                // See if this is a new value being set
                var isNewValue = !util.isEqual(val[attr], newValue);

                if (path.length === fullPathLength) {
                    // reached the attribute to be set

                    if (opts.unset) {
                        // unset the value
                        delete val[attr];

                        // Trigger Remove Event if array being set to null
                        if (util.isArray(val)) {
                            var parentPath = createAttrStr(util.initial(attrPath));
                            model.delayedTrigger('remove:' + parentPath, model, val[attr]);
                        }
                    } else {
                        // Set the new value
                        val[attr] = newValue;
                    }

                    // Trigger Change Event if new values are being set
                    if (!opts.silent && util.isObject(newValue) && isNewValue) {
                        var visited = [];
                        var checkChanges = function(obj, prefix) {
                            // Don't choke on circular references
                            if (util.indexOf(visited, obj) > -1) {
                                return;
                            } else {
                                visited.push(obj);
                            }

                            var nestedAttr, nestedVal;
                            for (var a in obj) {
                                if (obj.hasOwnProperty(a)) {
                                    nestedAttr = prefix + '.' + a;
                                    nestedVal = obj[a];
                                    if (!util.isEqual(model.get(nestedAttr), nestedVal)) {
                                        model.delayedChange(nestedAttr, nestedVal, opts);
                                    }
                                    if (util.isObject(nestedVal)) {
                                        checkChanges(nestedVal, nestedAttr);
                                    }
                                }
                            }
                        };
                        checkChanges(newValue, attrStr);

                    }


                } else if (!val[attr]) {
                    if (util.isNumber(next)) {
                        val[attr] = [];
                    } else {
                        val[attr] = {};
                    }
                }

                if (!opts.silent) {
                    // let the superclass handle change events for top-level attributes
                    if (path.length > 1 && isNewValue) {
                        model.delayedChange(attrStr, val[attr], opts);
                    }

                    if (util.isArray(val[attr])) {
                        model.delayedTrigger('add:' + attrStr, model, val[attr]);
                    }
                }
            });
        }

    });
});

